import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type Campaign } from '../../api/communication';

export function CampaignManagerPage() {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [name, setName] = useState('');
  const [channel, setChannel] = useState('email');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const load = () => {
    void communicationApi.listCampaigns().then((r) => setCampaigns(r.campaigns)).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      await communicationApi.createCampaign({ name, channel });
      setName('');
      load();
    } catch (e) {
      setError(String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Campaign Manager</h1>
      <div className="mt-6 flex flex-wrap gap-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Campaign name"
          className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
        <select value={channel} onChange={(e) => setChannel(e.target.value)}
          className="rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900">
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="push">Push</option>
        </select>
        <button onClick={() => void create()} disabled={loading}
          className="rounded bg-slate-900 px-4 py-2 text-white dark:bg-slate-100 dark:text-slate-900">
          Create Campaign
        </button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {campaigns.map((c) => (
          <li key={c.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{c.name}</span>
              <span className="rounded bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{c.status}</span>
            </div>
            <p className="mt-1 text-sm text-slate-500">{c.channel} · {c.type}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
